import { render } from "./AdminViewPaymentLiquidation.vue?vue&type=template&id=347ca918"
import script from "./AdminViewPaymentLiquidation.vue?vue&type=script&lang=js"
export * from "./AdminViewPaymentLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__